import { render, staticRenderFns } from "./VideoQueue.vue?vue&type=template&id=43a2b5ea&scoped=true&"
import script from "./VideoQueue.vue?vue&type=script&lang=js&"
export * from "./VideoQueue.vue?vue&type=script&lang=js&"
import style0 from "./VideoQueue.vue?vue&type=style&index=0&id=43a2b5ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a2b5ea",
  null
  
)

export default component.exports